/*
 # ## jQuery.multicomplete
 #
 # * Project: Opal
 # * Author: Jordan Cole / [Opal Labs](http://workwithopal.com)
 # * Description: AJAX-driven autocomplete for multiple items in a single visual
 # input. Inspired by Tumblr, Facebook, and OS X.
 # * License: BSD
 # * Version: 2.0
 # * Dependencies: jQuery 1.7+, jQuery.lazybind, Opal.plugin.suggestions
 #
 # #### Options
 #
 # * `class_name`: `String`, optional
 # * `field_name`: `String`, required
 # * `item_template`: `String`, optional
 # * `missing_suggestion_template`: `String` or `false`, optional
 # * `new_field_name`: `String` or `false`, optional
 # * `no_suggestions_template`: `String` or `false`, optional
 # * `search_params`: `Object`, optional
 # * `suggestion_template`: `String`, optional
 # * `url_prefix`: `String`, required
 #
 # #### Setup
 #
 # Given `$("#example").multicomplete({ field_name: "x" });` [^1] the plugin
 # expects the following HTML structure:
 #
 #     div#example_holder
 #       .chosen_items [^2]
 #         div.item
 #           input type="text" name="x" value="y" title="z"
 #         [...]
 #       input#example
 #
 # This is converted to:
 #
 #     div#example_holder.multicomplete.<`class_name`>
 #       .chosen_items
 #         div.item
 #           span.title
 #             "z"
 #           span.remove
 #           input type="hidden" name="x" value="y"
 #         [...]
 #       input#example
 #
 # [^1]: The `field_name` option must be specified so the plugin can set the
 # `name` attribute on hidden `<input>`s in `.chosen_items` (`x` in these
 # examples). These `<input>`s hold the actual data that will be submitted in
 # your form.
 # [^2]: Optional; for pre-filled/existing data. If `.chosen_items` is not
 # present the plugin will automatically generate it.
 #
 # #### Usage
 #
 # Clicking anywhere in `#example_holder` focuses `#example`. As the user types
 # into `#example` its width will be automatically adjusted to fit the user's
 # input, unless doing so would make `#example` wider than the inner width of
 # `#example_holder`.
 #
 # `.item`s can be removed by clicking their `.remove`. If `#example` is empty
 # and there are chosen items, hitting backspace once will add a `highlight`
 # class to the `.item` immediately before `#example`. Hitting backspace a
 # second time will remove the highlighted `.item`. `.item`s can also be
 # navigated using the left and right arrow keys.
 #
 # Typing into `#example` will make AJAX calls to
 #     <`url_prefix`><`#example`'s value>?<`search_params`>.
 # E.g., if `url_prefix` is `"/entries/search/"` and `#example`'s value is
 # `magnus`, the resulting call will be `/entries/search/magnus?`; adding
 # `search_params: { a: 15, b: "foo" }` will change the call to
 # `/entries/search/magnus?a=15&b=foo`.
 #
 # A valid JSON object must be returned from the AJAX call. The structure
 # should be:
 #
 #     {
 #       "status": "success", [^3]
 #       "results": [
 #         { "value": "foo", "title": "bar" } [^4]
 #         [...]
 #       ] [^5]
 #     }
 #
 # `"results"` will be rendered into `suggestions_template` via
 # `Opal.plugin.suggestions` using Handlebars.js.
 # * If there's at least one item in `"results"` and
 # `missing_suggestion_template` isn't `false`, `missing_suggestion_template`
 # will be rendered at the end of the suggestion list.
 # * If `"results"` is empty and `no_suggestions_template` isn't false, an
 # otherwise-empty suggestion list will be shown with `no_suggestions_template`
 # rendered.
 #
 # [^3]: Or `"error"`. Note: there is currently no error-recovery mechanism.
 # [^4]: Objects in the `results` array must include keys named `title` and
 # `value`. Any other key/value pairs will be interpolated into
 # `suggestions_template` as appropriate.
 # [^5]: If the server has no results, `"results"` should be an empty array.
 #
 */

;(function ($, window, document) {
  var item_template =
      "<div class='item {{type}}'><span class='title'>{{title}}</span>" +
      "<span class='sprite-global remove'></span>" +
      "<input type='hidden' class='value' name='' value='{{value}}'></div>",
    missing_suggestion_template =
      "<li class='item missing_item'>" +
      "<span class='title'>{{{title}}}</span>" +
      "{{#if subtitle}}<span class='secondary'>{{subtitle}}</span>{{/if}}" +
      "<input type='hidden' class='value' value='{{value}}'>" +
      '</li>',
    no_suggestions_template =
      "<li class='item no_items'>" +
      "<span class='title'>No results found.</span>" +
      '</li>',
    suggestion_template =
      "<li class='item suggestion {{type}}'>" +
      "{{#if image}}<span class='image' style='background-image:url({{image}});'></span>{{/if}}" +
      "<span class='title'>{{{title}}}</span>" +
      "{{#if subtitle}}<span class='secondary'>{{subtitle}}</span>{{/if}}" +
      "{{#if logo}}<span class='logo' style='background-image:url({{logo}})'></span>{{/if}}" +
      "<input type='hidden' class='value' value='{{value}}'>" +
      "{{#if type}}<input type='hidden' class='type' value='{{type}}'>{{/if}}" +
      '</li>',
    suggestions_holder_template = "<ul class='suggestions'></ul>",
    resize_suggestions = function ($list, $holder) {
      var sizes = Opal.toolkit.css_prop($holder, [
        'border-top-width',
        'border-bottom-width',
        'padding-left',
        'padding-right',
      ])

      $list.css({
        left: $holder.position().left,
        top:
          $holder.outerHeight() -
          parseInt(sizes['border-bottom-width'], 10) -
          parseInt(sizes['border-top-width'], 10),
        width: $holder.innerWidth() - parseInt(sizes['padding-left'], 10),
      })
    },
    pluginName = 'multicomplete',
    is_initialized = false,
    defaults = {
      after_holder_click: function () {},
      after_keyup: function () {},
      after_hide_suggestions: function () {},
      after_show_suggestions: function () {},
      always_show_suggestions: false,
      auto_focus: true,
      before_hide_suggestions: function () {},
      before_show_suggestions: function () {},
      can_choose_missing_suggestion: false,
      can_choose_no_suggestions: false,
      class_name: '',
      fetch_remote: true,
      field_name: '',
      item_limit: null,
      item_template: item_template,
      missing_suggestion_after_choose: null,
      missing_suggestion_template: missing_suggestion_template,
      no_suggestions_after_choose: null,
      no_suggestions_template: no_suggestions_template,
      search_params: {},
      stop_words: [],
      resize_suggestions: resize_suggestions,
      response_key: 'results',
      test_pattern: null,
      test_pattern_callback: null,
      suggestion_template: suggestion_template,
      suggestions_holder_template: suggestions_holder_template,
      suggestion_selected_callback: null,
      url_prefix: '',
    }

  // `_blur` and `_focus` have a leading underscore to avoid naming
  // conflicts.
  function Input(objects) {
    var that = this,
      $chosen_item_list,
      $holder,
      $input

    // Simulate blur event on `$holder`.
    that._blur = function () {
      $holder.removeClass('focus')
      $chosen_item_list.children('.item.selected').removeClass('selected')
      // Hide tooltips
      $chosen_item_list.children('.item').trigger('mouseleave')
    }

    // Simulate focus event on `$holder`.
    that._focus = function () {
      $holder.addClass('focus')

      // Because of initialization order `$chosen_item_list` may not be set
      // when we first instantiate `Input`. This makes sure we have a valid
      // reference.
      if (0 === $chosen_item_list.size()) {
        $chosen_item_list = $holder.children('.chosen_items')
      }

      // remove `selected` class from last chosen item in case user has hit
      // backspace
      if (0 < $chosen_item_list.children('.item').size()) {
        $chosen_item_list.children('.item:last').removeClass('selected')
      }
    }

    // Clean up, e.g. after adding a suggestion.
    that.reset = function () {
      $input.val('')
      $input.trigger('focus')
    }

    // Resize `$input` based on the text inside. The text is copied into a
    // `<span>` with identical text styling; the width of the span is the new
    // width of `$input`. (Inspired by how Facebook's multicomplete seems to
    // work, based on stepping through execution.)
    that.resize = function () {
      var $copy = $("<span class='duplicate'>" + $input.val() + '</span>'),
        FUDGE_FACTOR = 12,
        new_width = 0
      $holder.append($copy)
      // There tends to be a slight delay between a user's keyup and this
      // method's execution, so add a few extra px to hide the lag.
      new_width = $copy.width() + FUDGE_FACTOR
      $copy.remove()
      // `$input` should never be wider than `$holder`.
      if (new_width < $holder.width()) {
        $input.width(new_width)
      }
    }

    // private
    function initialize() {
      $chosen_item_list = objects.$chosen_item_list
      $holder = objects.$holder
      $input = objects.$input
    }
    initialize()

    return that
  }

  function Items(objects) {
    var that = this,
      ITEM_TEMPLATE = objects.ITEM_TEMPLATE,
      $chosen_item_list = objects.$chosen_item_list,
      $holder = objects.$holder,
      $input = objects.$input,
      settings = objects.settings

    // Add item to `$chosen_item_list`.
    //
    // TODO Rewrite to just take an `options` argument. Did this the cheap
    // way for sake of time. /jordan, 24-Nov-12
    that.add = function (value, title, extra) {
      var data = $.extend(
          {},
          {
            title: title,
            value: value,
          },
          extra
        ),
        existing_values = [],
        name_template,
        name,
        $item = $(ITEM_TEMPLATE(data)),
        current_value

      // Update `name`.
      if ('function' === typeof settings.field_name) {
        name_template = settings.field_name(data)
      } else {
        name_template = settings.field_name
      }
      name = Handlebars.compile(name_template)(data)
      $item.find('.value').prop('name', name)

      function chosen_item_unique_name($chosen_item) {
        return (
          $.trim($chosen_item.prop('class')).split(' ').join('_') +
          '_' +
          $chosen_item.find('.value').prop('value')
        )
      }
      current_value = chosen_item_unique_name($item)
      existing_values = $chosen_item_list.find('.item').map(function () {
        return chosen_item_unique_name($(this))
      })

      if ($.inArray(current_value, existing_values) < 0) {
        $chosen_item_list.append($item)
        $item.tooltip({
          always_center: true,
        })

        if (is_initialized) {
          // tooltip doesn't initialize until `mouseenter`, but in this case
          // needs to initialize right away. opallabs/opal#394
          $item.trigger('mouseenter')
        }

        // Remove item when its `.remove` is clicked.
        $item.children('.remove').click(function () {
          that.remove($item)
        })

        $item.bind('click.multicomplete', function () {
          $input.trigger('focus')
          $item.addClass('selected')
        })

        $holder.trigger('change')
      }

      if (!data.prepopulated) {
        var callback = settings.suggestion_selected_callback
        if (callback) {
          callback($item)
        }
      }

      that._toggle_input_for_limit()
    }

    that.navigate = function (direction) {
      var $current_item = $chosen_item_list.children('.item.selected'),
        $next_item

      // If $input is empty...
      if ('' === $input.val()) {
        // ... and there are chosen items...
        if (0 < $chosen_item_list.children('.item').size()) {
          if ('left' === direction) {
            $next_item = $current_item.prev('.item')

            // ... if an item is currently selected...
            if (0 !== $current_item.size()) {
              // ... try to select the item to the left.
              if (0 !== $next_item.size()) {
                $current_item.removeClass('selected')
                $next_item.addClass('selected')
              }
              // ... otherwise, highlight the last `.item`.
            } else {
              var $item = $chosen_item_list.children('.item:last')
              $item.addClass('selected')
            }
          } else if ('right' === direction) {
            $next_item = $current_item.next('.item')

            // ... remove the current item's highlight...
            $current_item.removeClass('selected')
            // ... and try to select the item to the right.
            if (0 !== $next_item.size()) {
              $next_item.addClass('selected')
            }
            // If we're at the last item, we assume the user wanted to be
            // back at `$input`.
          }
        }
      }
    }

    // Convert any existing `.item`s to the multicomplete structure;
    // generate missing structure as needed.
    that.preprocess = function () {
      var $raw_item

      // No existing items.
      if (0 === $chosen_item_list.size()) {
        $chosen_item_list = $("<div class='chosen_items'>")
        $holder.prepend($chosen_item_list)
        // Convert existing items.
      } else {
        $chosen_item_list.detach()
        $holder.prepend($chosen_item_list)

        $chosen_item_list.children('.item').each(function () {
          $raw_item = $(this).children('input')

          // Don't run if the item has already been processed (signified by
          // the input having a type)
          if (!$raw_item.attr('type')) {
            var data = { prepopulated: true }

            if ($raw_item.data('type')) {
              data.type = $raw_item.data('type')
            }

            if ($raw_item.attr('title')) {
              that.add($raw_item.val(), $raw_item.attr('title'), data)
            } else {
              var $title_item = $(this).find('.title')
              that.add($raw_item.val(), $title_item.text(), data)
            }
            $(this).remove()
          }
        })
      }

      return $chosen_item_list
    }

    that.reset = function () {
      $chosen_item_list.children('.item').remove()
      $chosen_item_list = $holder.children('.chosen_items')
    }

    that.remove = function ($item) {
      var $tooltip = $('#' + $item.data('tip_id'))
      $tooltip.remove()

      // In case external code is monitoring this field, clear its value
      // so the external code can know it's going away.
      $item.find('.value').val('').trigger('change')

      $item.remove()
      $input.trigger('focus')

      that._toggle_input_for_limit()

      $holder.trigger('change')
    }

    // private
    that._toggle_input_for_limit = function () {
      var chosen_items = $chosen_item_list.children('.item').length,
        disabled = settings.item_limit <= chosen_items

      if (settings.item_limit) {
        $input.prop('disabled', disabled)

        if (!disabled) {
          $input.trigger('focus')
        }
      }
    }

    return that
  }

  function Plugin(elem, options) {
    var that = this,
      suggestions = null,
      $elem = $(elem),
      $holder = $elem.parent(),
      $chosen_item_list = $holder.children('.chosen_items'),
      $input = $elem,
      input,
      items,
      settings = $.extend({}, defaults, options),
      is_active = false,
      lazy_blur_timer = null,
      click_listener_namespace = ''

    _prepare_suggestions()

    // Hide the suggestion list when `$input` loses focus. But it's not quite
    // that simple, because clicking in `$holder` or the suggestion list will
    // also blur `$input`.
    //
    // The obvious answer is to see what element was interacted with, and
    // kill the blur if the element is inside `$holder`. Unfortunately, that
    // doesn't work--there's no reliable, cross-browser way to get the new
    // element.
    //
    // Here, the approach is to have `Plugin#initialize` set up a global
    // click listener that toggles `is_active`. When the blur event fires,
    // it waits a moment before running the actual blur code.
    //
    // References:
    // * http://stackoverflow.com/questions/121499/
    // * http://stackoverflow.com/questions/11544554/
    function _body_click(e) {
      var $target = $(e.target)

      is_active = $target.closest('.multicomplete').is($holder)
    }
    function _input_blur() {
      var delay = 100

      clearTimeout(lazy_blur_timer)
      lazy_blur_timer = setTimeout(_input_lazy_blur, delay)

      return false
    }
    function _input_lazy_blur() {
      var phrase = $.trim($input.val())

      if (phrase !== '') {
        $input.addClass('invalid')
      }

      if (!is_active) {
        input._blur()
        suggestions.hide(true)
        // Clean up click listener
        $(document.body).off('mousedown.' + click_listener_namespace)
      }
    }
    function _input_focus() {
      $input.removeClass('invalid')

      // Setup for `_input_blur`
      if (!is_active) {
        click_listener_namespace = 'multicomplete_' + new Date().getTime()
        $(document.body).on(
          'mousedown.' + click_listener_namespace,
          _body_click
        )
      }

      clearTimeout(lazy_blur_timer)
      is_active = true

      input._focus()

      setTimeout(function () {
        var phrase = $.trim($input.val())

        if (
          ('' !== phrase && -1 === $.inArray(phrase, settings.stop_words)) ||
          settings.always_show_suggestions
        ) {
          suggestions.show()
        }
      }, 1)
    }
    function _input_keydown(e) {
      var codepoint = e.charCode || e.keyCode,
        phrase = $.trim($input.val())

      if ('' === phrase || -1 < $.inArray(phrase, settings.stop_words)) {
        suggestions.reset()
      }

      switch (codepoint) {
        // Will need to adjust this if tab-completion is added.
        case Opal.metakeys.tab:
          is_active = false
          break
        case Opal.metakeys.backspace:
          // If `$input` is empty...
          if ('' === phrase && -1 === $.inArray(phrase, settings.stop_words)) {
            // ... and there are chosen items...
            if (0 < $chosen_item_list.children('.item').size()) {
              var $item = $chosen_item_list.children('.item.selected')
              // ... and one is highlighted, remove it.
              if (0 < $item.size()) {
                items.remove($item)
                // ... otherwise, highlight the last item.
              } else {
                $item = $chosen_item_list.children('.item:last')
                $item.addClass('selected')
              }
            }
          }
          break
        case Opal.metakeys.left_arrow:
          items.navigate('left')
          break
        case Opal.metakeys.right_arrow:
          items.navigate('right')
          break
        // Normal character input, so remove highlight from `.item`.
        default:
          $chosen_item_list.children('.item.selected').removeClass('selected')
          input.resize()
      }
    }
    function _input_keyup() {
      var phrase = $.trim($input.val())

      input.resize()

      if ('' === phrase || -1 < $.inArray(phrase, settings.stop_words)) {
        suggestions.reset()
      }
      settings.after_keyup({
        phrase: phrase,
        suggestions: suggestions,
        input: $input,
      })
    }
    function _input_lazytype(e, text) {
      var phrase = $.trim(text)

      if ('' === phrase || -1 < $.inArray(phrase, settings.stop_words)) {
        suggestions.reset()
      } else {
        _get_suggestions(phrase)
      }
    }

    function _get_suggestions(phrase) {
      var query_url = '',
        suggestions_pattern = null,
        callback = null

      if (null !== settings.test_pattern) {
        // @opallabs/opal#566
        phrase = phrase.match(settings.test_pattern)[0]
        // @opallabs/opal#559
        phrase = phrase.replace(/[\^$]/g, '')
      }

      function default_callback() {
        suggestions_pattern = new RegExp('(' + phrase + ')', 'i')

        if (settings.fetch_remote && '' !== settings.url_prefix) {
          query_url = settings.url_prefix + encodeURIComponent(phrase) + '?'

          // Merge `search_params` into query.
          $.each(settings.search_params, function (k, v) {
            var value = 'function' === typeof v ? v.call() : v

            query_url += k + '=' + value + '&'
          })
        } else {
          query_url = ''
        }

        // Proceed if there's no `test_pattern`, or `phrase` matches
        // `test_pattern`.
        if (
          null === settings.test_pattern ||
          (settings.test_pattern && settings.test_pattern.test(phrase))
        ) {
          // Update `suggestions`' pattern so `$1` matches `phrase`.
          suggestions.pattern(suggestions_pattern)
          suggestions.fetch(query_url)
        }
      }

      callback = settings.test_pattern_callback || default_callback
      callback({
        default: default_callback,
        phrase: phrase,
        suggestions: suggestions,
        input: $input,
      })
    }

    // `$holder`
    function _holder_click(e) {
      var $target = $(e.target),
        $item = $target.closest('.item'),
        $suggestions = $target.closest('.suggestions')

      e.preventDefault()

      if ($(e.target).closest('.drop-icon')[0]) {
        if ($holder.hasClass('focus')) {
          is_active = false
          $input.trigger('blur')
        } else {
          is_active = true
          $input.trigger('focus')
        }
        return false
      }

      // Clicking in `$holder` focuses `$input`, provided the click is not
      // on a chosen `.item` or the suggestions list.
      if (0 === $item.length && 0 === $suggestions.length) {
        $input.trigger('focus')

        settings.after_holder_click({
          suggestions: suggestions,
          $target: $target,
        })
      }
    }
    // Note: `"insert"` trigger needs to pass an array, or only `value` will
    // be set.
    //
    //     $foo.trigger("insert", [34343, "happy"])
    //     $foo.trigger("insert", [34343, "happy", { bar: "baz" } ])
    function _holder_insert(e, value, title, extra_data) {
      if (null !== value && '' !== title) {
        items.add(value, title, extra_data)
      }

      suggestions.reset()
      input.reset()
    }
    function _holder_reprocess() {
      $chosen_item_list = items.preprocess()
    }
    function _holder_reset() {
      suggestions.reset()
      input.reset()
      items.reset()
    }

    function _prepare_suggestions() {
      suggestions = Opal.plugin.suggestions($input, {
        always_show: settings.always_show_suggestions,
        can_choose_missing_item: settings.can_choose_missing_suggestion,
        can_choose_no_items: settings.can_choose_no_suggestions,
        class_name: settings.class_name,
        fetch_remote: settings.fetch_remote,
        holder_template: settings.suggestions_holder_template,
        missing_item_template: settings.missing_suggestion_template,
        no_items_template: settings.no_suggestions_template,
        item_template: settings.suggestion_template,
        item_title_key: settings.item_title_key,
        response_key: settings.response_key,
      })

      suggestions.after_choose = function ($target) {
        var $item = $target.closest('.item'),
          data = {}

        // TODO Find a more general way to do this. Maybe pass all hidden
        // inputs? /jordan, 24-Nov-12
        if ($item.children('.type').length > 0) {
          data.type = $item.children('.type').val()
        }
        items.add(
          $item.children('.value').val(),
          $item.find('.title').text(),
          data
        )
        input.reset()

        return false
      }
      suggestions.after_hide = settings.after_hide_suggestions
      suggestions.after_show = function ($list) {
        suggestions.resize($list)
      }
      suggestions.before_hide = settings.before_hide_suggestions
      suggestions.before_show = settings.before_show_suggestions
      suggestions.resize = function ($list) {
        settings.resize_suggestions($list, $holder)
      }
      $input.trigger('resize.suggestions')

      if (null !== settings.missing_suggestion_after_choose) {
        suggestions.missing_item_after_choose =
          settings.missing_suggestion_after_choose
      }
      if (null !== settings.no_suggestions_after_choose) {
        suggestions.no_items_after_choose = settings.no_suggestions_after_choose
      }
    }

    that.reset = function () {
      $chosen_item_list = items.preprocess()

      $input.val('')

      suggestions.reset()
      _prepare_suggestions()
    }

    that.initialize = function () {
      var objects = {
        $chosen_item_list: $chosen_item_list,
        $holder: $holder,
        $input: $input,
        ITEM_TEMPLATE: window.prepare_template(settings.item_template, {
          compile_if_function: false,
        }),
        settings: settings,
      }

      items = new Items(objects)
      input = new Input(objects)

      // `$holder`
      $holder.addClass('multicomplete').addClass(settings.class_name)
      $holder
        .off('.multicomplete')
        .on('click.multicomplete', _holder_click)
        .on('insert.multicomplete', _holder_insert)
        .on('reprocess.multicomplete', _holder_reprocess)
        .on('reset.multicomplete', _holder_reset)

      // `$input`
      $input
        .off('.multicomplete')
        .on('keydown.multicomplete', _input_keydown)
        .on('blur.multicomplete', _input_blur)
        .on('focus.multicomplete', _input_focus)
        .on('keyup.multicomplete', _input_keyup)
        .lazytype({
          callback: _input_lazytype,
          ignore_meta_keys: true,
          minimum_characters: 2,
          wait: 20,
        })

      // Preprocess
      $chosen_item_list = items.preprocess()
      if ('' !== $input.val()) {
        items.add($input.val(), $input.attr('title'))
      }
      if (settings.auto_focus) {
        input.reset()
      }
      // Reset $input's `name` to prevent any junk data when the form is
      // submitted.
      $input.attr({ name: '', title: '' })

      is_initialized = true
    }
    that.initialize()

    return that
  }

  $.fn[pluginName] = function (options) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options))
      }
    })
  }
})(jQuery, window, document)
